import { Component, OnInit } from '@angular/core';
import { AdminService } from "../admin.service";
import { ViewChild } from '@angular/core';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-admin-vendors',
  templateUrl: './admin-vendors.component.html',
  styleUrls: ['./admin-vendors.component.css'],
  
})
export class AdminVendorsComponent implements OnInit {
  token = localStorage.getItem('adminToken');
  activeTab: 'summary' | 'list' = 'summary';
  vendorSummaryList: any[] = [];
  vendorList: any[] = [];
  selectedRegion: string | null = null;
  regionCount: number = 0;
  @ViewChild('dt') dt!: Table;

  constructor(private adminService: AdminService) {}

  ngOnInit(): void {
    this.activeTab = 'summary';
    this.loadVendorSummary();
  }

  loadVendorSummary(): void {
    if (!this.token) return;
    this.adminService.getAllVendors(this.token).subscribe({
      next: (res: any) => {
        this.vendorSummaryList = res.body?.data || [];
      },
      error: (err) => {
        console.error('Failed to load vendor summary:', err);
      },
    });
  }
  
  
  onGlobalFilter(event: Event, table: Table) {
    const input = event.target as HTMLInputElement;
    table.filterGlobal(input.value, 'contains');
  }

  get totalVendors(): number {
    return this.vendorSummaryList?.reduce((sum, region) => sum + (region.totalrecords || 0), 0);
  }
  
  toTitleCase(value: string): string {
    if (!value) return '';
    return value
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  viewRegion(region: string, count: number): void {
    if (!this.token) return;
    this.selectedRegion = region;
    this.regionCount = count;
    this.adminService.getVendorsByRegion(this.token, region).subscribe({
      next: (res: any) => {
        this.vendorList = res.body?.data || [];
        this.activeTab = 'list';
      },
      error: (err) => {
        console.error('Failed to load region vendors:', err);
      },
    });
  }

}
